import { render, staticRenderFns } from "./BatteryHealthSection.vue?vue&type=template&id=58d6160e&scoped=true"
import script from "./BatteryHealthSection.vue?vue&type=script&lang=js"
export * from "./BatteryHealthSection.vue?vue&type=script&lang=js"
import style0 from "./BatteryHealthSection.vue?vue&type=style&index=0&id=58d6160e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6160e",
  null
  
)

export default component.exports